export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["PERF"] = "PERF";
})(LogLevel || (LogLevel = {}));
export const Logger = {
    info: (message, context) => console.log(`[${new Date().toISOString()}] [INFO] ${message}`, context ?? ""),
    warn: (message, context) => console.warn(`[${new Date().toISOString()}] [WARN] ${message}`, context ?? ""),
    error: (message, context) => console.error(`[${new Date().toISOString()}] [ERROR] ${message}`, context ?? ""),
    perf: (message, duration, context) => console.log(`[${new Date().toISOString()}] [PERF] ${message} (${duration.toFixed(2)}ms)`, context ?? ""),
};
//# sourceMappingURL=logger.js.map